import api from "./index";

export async function uploadFile(formData) {
  return api.post(`/files`, formData);
}
